/**
 * App-owned localStorage / sessionStorage keys.
 *
 * IMPORTANT: Only clear these specific keys on sign-out or reset.
 * Never use localStorage.clear() — it would wipe data owned by
 * third-party libraries running on the same domain.
 */
export const SESSION_KEYS_TO_CLEAR = [
  "has_seen_onboarding",
  "birthday_dismissed_today",
] as const;